import {ContentHotel} from '@findhotel/sapi'

export const getGalleryImageAlt = (
  hotelName: string,
  image: ContentHotel['images'][number],
  index: number
): string => {
  const label = image.category?.[0]?.name
  return label ? `${hotelName} - ${label}` : `${hotelName} - Image ${index + 1}`
}
